var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import { FlexBox, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Field, FieldArray, Form, reduxForm, } from 'redux-form';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { FlowNodeTypes, } from '../../../powerFlowShared/components/types';
import InputField from '../../../shared/util/InputField';
import SelectField from '../../../shared/util/SelectField';
import { getRequestID } from '../../../shared/util/request';
const validate = (values) => {
    const errors = {};
    if (!values.rules || !values.rules.length) {
        errors.rules = {
            _error: 'At least one rule must be entered - click on "Add"',
        };
    }
    else {
        const ruleArrayErrors = [];
        values.rules.forEach((rule, index) => {
            const ruleErrors = {};
            if (!rule) {
                errors.rules = {
                    _error: 'At least one rule must be entered - click on "Add".',
                };
            }
            if (!rule || !rule.type) {
                ruleErrors.type = 'Required';
                ruleArrayErrors[index] = ruleErrors;
            }
            if (!rule || !rule.rule) {
                ruleErrors.rule = 'Required';
                ruleArrayErrors[index] = ruleErrors;
            }
            if (!rule || !rule.match) {
                ruleErrors.match = 'Required';
                ruleArrayErrors[index] = ruleErrors;
            }
        });
        if (ruleArrayErrors.length) {
            errors.rules = ruleArrayErrors;
        }
    }
    return errors;
};
const ListContent = ({ fields, meta: { error, submitFailed }, }) => {
    const typeOptions = [
        {
            label: 'Subject',
            value: 'subject',
        },
        {
            label: 'Body',
            value: 'body',
        },
        {
            label: 'From',
            value: 'from',
        },
    ];
    const targetOptions = [
        {
            label: 'Contains',
            value: 'contains',
        },
        {
            label: 'Does not contain',
            value: 'not-contains',
        },
        {
            label: 'Starts with',
            value: 'prefix',
        },
        {
            label: 'Ends with',
            value: 'suffix',
        },
        {
            label: 'is',
            value: 'equals',
        },
        {
            label: 'is not',
            value: 'not-equals',
        },
    ];
    return (_jsxs("div", { children: [_jsx("div", Object.assign({ className: "section-header mt10 mb10" }, { children: _jsx("h5", Object.assign({ className: "hidden" }, { children: "Content" })) })), submitFailed && error && _jsx("span", { children: error }), fields.map((rule, index) => {
                return (_jsxs("div", Object.assign({ className: "input-field-content" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn btn-xm remove-content pull-right btn-remove", title: "Remove", onClick: () => fields.remove(index) }, { children: _jsx(DixaIcon, { icon: "close" }) })), _jsxs("strong", Object.assign({ className: "hidden" }, { children: ["Content Rule #", index + 1] })), _jsxs(Field, Object.assign({ name: `${rule}.type`, isRequired: true, displayName: "Field", component: SelectField, className: "form-control", style: {
                                width: '30%',
                                marginRight: '1%',
                            } }, { children: [_jsx("option", Object.assign({ hidden: true }, { children: " - Select a target" })), typeOptions.map((option, index) => {
                                    return (_jsx("option", Object.assign({ value: option.value }, { children: option.label }), index));
                                })] })), _jsxs(Field, Object.assign({ name: `${rule}.rule`, isRequired: true, displayName: "Rule", component: SelectField, className: "form-control", style: {
                                width: '30%',
                                marginRight: '1%',
                            } }, { children: [_jsx("option", Object.assign({ hidden: true }, { children: " - Type of rule" })), targetOptions.map((option, index) => {
                                    return (_jsx("option", Object.assign({ value: option.value }, { children: option.label }), index));
                                })] })), _jsx(Field, { name: `${rule}.match`, isRequired: true, type: "text", displayName: "Value", placeholder: `Eg. billing`, component: InputField, className: "form-control", style: {
                                width: '32%',
                            } })] }), index));
            }), _jsxs("button", Object.assign({ type: "button", className: "btn btn-primary btn-block outlined add-rule", onClick: () => fields.push({}) }, { children: [_jsx(DixaIcon, { icon: "plus" }), "Add Rule"] }))] }));
};
class ContentModalImpl extends Component {
    handleSaveClick(values) {
        const payload = Object.assign(Object.assign({}, this.props.node.payload), { rules: values.rules, rule_type: values.rule_type });
        if (!this.props.node.payload || !this.props.node.payload.match_node_id) {
            payload.match_node_id = getRequestID();
        }
        else {
            payload.match_node_id = this.props.node.payload.match_node_id;
        }
        if (!this.props.node.payload ||
            !this.props.node.payload.non_match_node_id) {
            payload.non_match_node_id = getRequestID();
        }
        else {
            payload.non_match_node_id = this.props.node.payload.non_match_node_id;
        }
        const nodeOptions = Object.assign(Object.assign({}, this.props.node), { badges: [], childIds: [], icon: 'i-align-left', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.CONTENT, overlay: [], payload: payload, text: 'Content' });
        this.props.replaceNode(nodeOptions);
        this.props.triggerClose();
    }
    closeModal() {
        const { destroy, triggerClose } = this.props;
        destroy();
        triggerClose();
    }
    render() {
        const { node, nodeLabel, handleSubmit } = this.props;
        return (_jsx("div", Object.assign({ className: "email-content modal-emailflow-holder" }, { children: _jsxs(Form, Object.assign({ onSubmit: handleSubmit(this.handleSaveClick) }, { children: [_jsx(ModalHead, Object.assign({ title: nodeLabel, onClose: this.closeModal }, { children: "The content setting can be used to change what should happen to an email conversation based on the content of the email." })), _jsx(ModalBody, { children: _jsxs(FlexBox, Object.assign({ flexDirection: "column" }, { children: [_jsxs(Field, Object.assign({ name: "rule_type", isRequired: true, displayName: "Type", component: SelectField, className: "form-control", label: "Target" }, { children: [_jsx("option", Object.assign({ value: "any" }, { children: "If any of the following conditions are met" })), _jsx("option", Object.assign({ value: "all" }, { children: "If all of the following conditions are met" }))] })), _jsx(FieldArray, { name: "rules", component: ListContent })] })) }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(this.handleSaveClick), confirmName: getConfirmButtonVerb(node), cancelOnClick: this.closeModal })] })) })));
    }
}
__decorate([
    boundMethod
], ContentModalImpl.prototype, "handleSaveClick", null);
__decorate([
    boundMethod
], ContentModalImpl.prototype, "closeModal", null);
export const ContentModal = connect((_state, ownProps) => {
    let payload = {
        rules: [
            {
                type: 'subject',
                rule: 'contains',
                match: '',
            },
        ],
        rule_type: 'any',
    };
    if (ownProps.node.payload !== null) {
        payload = ownProps.node.payload;
    }
    return {
        payload,
        initialValues: payload,
    };
})(reduxForm({
    form: 'emailFlowContentForm',
    enableReinitialize: true,
    validate,
})(ContentModalImpl));
